import { render, staticRenderFns } from "./DetailDus.vue?vue&type=template&id=e08d0508&scoped=true&"
import script from "./DetailDus.vue?vue&type=script&lang=js&"
export * from "./DetailDus.vue?vue&type=script&lang=js&"
import style0 from "./DetailDus.vue?vue&type=style&index=0&id=e08d0508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08d0508",
  null
  
)

export default component.exports